<template>
  <div class="bot-arm-wrapper">
    <div class="bot-arm-shadow" :style="'background-image: url('+bot_arm_shadow+');'"></div>
    <div class="bot-arm" :style="'background-image: url('+bot_arm+');'"></div>
  </div>
</template>

<script>
  import botArm from '../.././assets/bot-arm.png'
  import botArmShadow from '../.././assets/bot-arm-shadow.png'

  import TweenMax from 'gsap/TweenMax';
  import TimelineMax from 'gsap/TimelineMax';

  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        exclude_from_nav: true,
        bot_arm_shadow: botArmShadow,
        bot_arm: botArm,
        matchBotTimelineTimeline: null,
        hoverTimeline: null
      }
    },
    mounted () {
      this.addFlightTimeline()
      this.addHoverAnimation()
    },
    computed: {
      ...mapGetters({
        active_section_name: 'getActiveSectionName',
        scroll_pos: 'getScrollPos',
        is_animating_scroll: 'getAnimatingScrollState'
      })
    },
    watch: {
      active_section_name (val) {
        if (val === 'passion') {
          if (!this.is_animating_scroll) { // && window.innerWidth > 1024
            this.matchBotTimelineTimeline.play()
          }
        }
      }
    },
    methods: {
      addHoverAnimation () {
        this.hoverTimeline = new TimelineMax({
          repeat: -1,
          yoyo: true
        })

        this.hoverTimeline.fromTo(this.$el, 2, {
          y: (window.innerWidth < 769) ? -700 : -980
        }, {
          y: (window.innerWidth < 769) ? -770 : -1050,
          ease: Power1.easeInOut
        })
        TweenMax.set(this.$el, {
          y: 0
        })

        this.hoverTimeline.pause()
      },
      addFlightTimeline () {
        let arm = this.$el.querySelector('.bot-arm')
        let armshadow = this.$el.querySelector('.bot-arm-shadow')
        let _this = this
        TweenMax.set(this.$el, {
          y: 0
        })
        TweenMax.set(armshadow, {
          autoAlpha: 0
        })
        this.matchBotTimelineTimeline = new TimelineMax({
          repeat: 0,
          onComplete () {
            _this.hoverTimeline.play()
          }
        })
        this.matchBotTimelineTimeline.to(this.$el, 2, {
          y: (window.innerWidth < 769) ? -800 : -1100
        }).to(arm, 1.6, {
          rotation: 50,
          ease: Power3.easeInOut
        }, 0).to(this.$el, 1.5, {
          y: (window.innerWidth < 769) ? -700 : -980,
          ease: Power1.easeInOut
        }).set(this.$el, {
          css: {
            zIndex: 2
          }
        }, 1.2).to(arm, 1.2, {
          rotation: 0,
          ease: Power1.easeInOut
        }, 2).to(armshadow, 0.3, {
          y: 20,
          x: 20,
          autoAlpha: 1
        }, 3.1)

        this.matchBotTimelineTimeline.pause()
      }
    }
  }
</script>


<style lang="scss">
  .bot-arm-wrapper {
    position: absolute;
    right: 1048/2+px;
    z-index: 1;
    @media screen and (max-width: 1560px) {
      right: 1048/3+px;
    }
    @media screen and (max-width: 768px) {
      transform: scale(0.7);
      right: 296px;
    }
    @media screen and (max-width: 640px) {
        display: none;
    }
  }
  .bot-arm {
    position: absolute;
    background-size: 100%;
    top: 226px;
    left: 46px;
    $bot_arm_width: 381;
    $bot_arm_height: 828;
    width: calc(#{$bot_arm_width/2}px);
    height: calc(#{$bot_arm_height/2}px);
    transform-origin: 210px 70px;
    @media screen and (max-width: 1560px) {
      top: 126px;
      left: 96px;
      width: calc(#{$bot_arm_width/3}px);
      height: calc(#{$bot_arm_height/3}px);
      transform-origin: 140px 47px;
    }
  }
  .bot-arm-shadow {
    position: absolute;
    background-size: 100%;
    top: 494px;
    left: 36px;
    $bot_arm_shadow_width: 352;
    $bot_arm_shadow_height: 276;
    width: calc(#{$bot_arm_shadow_width/2}px);
    height: calc(#{$bot_arm_shadow_height/2}px);
    @media screen and (max-width: 1560px) {
      top: 296px;
      left: 80px;
      width: calc(#{$bot_arm_shadow_width/3}px);
      height: calc(#{$bot_arm_shadow_height/3}px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/botArm.vue